import { get, put } from ".";

export const myCartableAreas = () => {
  return get(`/api/region/user/myCartableAreas`, true);
};
export const getStaticAccesses = (areaId) => {
  return get(`/api/region/user/staticAccesses/${areaId}`, true);
};
export const checkAccessToWareHouseDrug = () => {
  return get(`/api/jahadgar/drug/checkAccessToWareHouse`, true);
};
export const checkAccessToWareHouseEquipment = () => {
  return get(`/api/jahadgar/equipment/checkAccessToWareHouse`, true);
};
export const hasExternalReferralAccess = () => {
  return get(
    `/api/jahadgar/external_referrals/hasExternalReferralAccess`,
    true,
  );
};
export const myAccesses = () => {
  return get(`/api/user/my-accesses`, true);
};
export const getGroupAreas = (filter) => {
  return get(`/api/region/manage/getGroupAreas${filter ? filter : ""}`, true);
};
export const getGroupTrips = (filter) => {
  return get(`/api/region/manage/getGroupTrips${filter ? filter : ""}`, true);
};
export const getPatientReport = (patientId) => {
  return get(`/api/region/patient/patientReport/${patientId}`, true, {
    responseType: "blob",
  });
};
export const userReport = (query) => {
  return get(`/api/group/user/excel-report/?${query.toString()}`, true, {
    responseType: "blob",
  });
};
export const getEquipmentCount = (areaId) => {
  return get(`/api/equipment/list/${areaId}`, true);
};
export const addAllEquipmentsToArea = (areaId, data) => {
  return put(
    `/api/jahadgar/equipment/addAllEquipmentsToArea/${areaId}`,
    true,
    data,
  );
};
